import { useState, useEffect } from 'react';
import api from '../services/api';
import Sidebar from '../components/Sidebar';

export default function Contatos() {
  const [contatos, setContatos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [clienteContatos, setClienteContatos] = useState([]);
  const [mostrarForm, setMostrarForm] = useState(false);
  const [editando, setEditando] = useState(null);
  const [filtroPendente, setFiltroPendente] = useState(false);
  const [filtroTipo, setFiltroTipo] = useState('');
  const [filtroCliente, setFiltroCliente] = useState('');
  const [form, setForm] = useState({
    tipo_contato: '', cliente_id: '', cliente_contato_id: '',
    nome_contato: '', contato_externo: '', direcao: 'entrada',
    assunto: '', resumo: '', data_contato: '', pendente_cadastro: false
  });

  const usuario = JSON.parse(localStorage.getItem('usuario') || '{}');

  useEffect(() => { carregar(); carregarClientes(); }, []);

  async function carregar() {
    const res = await api.get('/contatos/');
    setContatos(res.data);
  }

  async function carregarClientes() {
    const res = await api.get('/clientes/');
    setClientes(res.data);
  }

  async function carregarClienteContatos(clienteId) {
    if (!clienteId) { setClienteContatos([]); return; }
    const res = await api.get(`/contatos/cliente-contatos/${clienteId}`);
    setClienteContatos(res.data);
  }

  async function salvar() {
    if (!form.tipo_contato) { alert('Selecione o tipo de contato!'); return; }
    if (!form.resumo.trim()) { alert('Resumo é obrigatório!'); return; }
    if (!form.data_contato) { alert('Data é obrigatória!'); return; }
    const dados = {
      ...form,
      cliente_id: form.cliente_id || null,
      cliente_contato_id: form.cliente_contato_id || null,
      pendente_cadastro: !form.cliente_id,
    };
    if (editando) {
      await api.put(`/contatos/${editando}`, dados);
    } else {
      await api.post('/contatos/', dados);
    }
    resetForm();
    carregar();
  }

  async function vincular(contato) {
    const clienteId = window.prompt('ID do cliente para vincular:');
    if (!clienteId) return;
    await api.put(`/contatos/${contato.id}/vincular?cliente_id=${clienteId}`);
    carregar();
  }

  function editar(c) {
    setForm({
      tipo_contato: c.tipo_contato, cliente_id: c.cliente_id || '',
      cliente_contato_id: c.cliente_contato_id || '', nome_contato: c.nome_contato || '',
      contato_externo: c.contato_externo || '', direcao: c.direcao,
      assunto: c.assunto || '', resumo: c.resumo || '',
      data_contato: c.data_contato?.substring(0, 16) || '', pendente_cadastro: c.pendente_cadastro
    });
    if (c.cliente_id) carregarClienteContatos(c.cliente_id);
    setEditando(c.id);
    setMostrarForm(true);
  }

  async function deletar(id) {
    if (window.confirm('Remover este contato?')) {
      await api.delete(`/contatos/${id}`);
      carregar();
    }
  }

  function resetForm() {
    setForm({ tipo_contato: '', cliente_id: '', cliente_contato_id: '', nome_contato: '', contato_externo: '', direcao: 'entrada', assunto: '', resumo: '', data_contato: '', pendente_cadastro: false });
    setEditando(null);
    setMostrarForm(false);
    setClienteContatos([]);
  }

  function nomeCliente(id) {
    const c = clientes.find(c => c.id === id);
    return c ? c.razao_social : '-';
  }

  function formatarData(dt) {
    if (!dt) return '—';
    return new Date(dt).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  }

  function iconeTipo(tipo) {
    if (tipo === 'whatsapp') return '💬';
    if (tipo === 'email') return '✉️';
    return '📞';
  }

  const filtrados = contatos.filter(c => {
    if (filtroPendente && !c.pendente_cadastro) return false;
    if (filtroTipo && c.tipo_contato !== filtroTipo) return false;
    if (filtroCliente && c.cliente_id !== parseInt(filtroCliente)) return false;
    return true;
  });

  const pendentesCount = contatos.filter(c => c.pendente_cadastro).length;

  return (
    <div style={styles.container}>
      <Sidebar />
      <div style={styles.conteudo}>
        <div style={styles.header}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <h1 style={styles.titulo}>Contatos</h1>
            {pendentesCount > 0 && (
              <span style={styles.badgePendente}>⚠️ {pendentesCount} pendente{pendentesCount > 1 ? 's' : ''}</span>
            )}
          </div>
          <button style={styles.botaoNovo} onClick={() => { setMostrarForm(true); setEditando(null); resetForm(); setMostrarForm(true); }}>
            + Novo Contato
          </button>
        </div>

        <div style={styles.filtros}>
          <select style={styles.filtroInput} value={filtroTipo} onChange={e => setFiltroTipo(e.target.value)}>
            <option value="">Todos os tipos</option>
            <option value="whatsapp">💬 WhatsApp</option>
            <option value="email">✉️ Email</option>
            <option value="outro">📞 Outro</option>
          </select>
          <select style={styles.filtroInput} value={filtroCliente} onChange={e => setFiltroCliente(e.target.value)}>
            <option value="">Todos os clientes</option>
            {clientes.map(c => <option key={c.id} value={c.id}>{c.razao_social}</option>)}
          </select>
          <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', color: '#555', cursor: 'pointer' }}>
            <input type="checkbox" checked={filtroPendente} onChange={e => setFiltroPendente(e.target.checked)} />
            Só pendentes
          </label>
        </div>

        {mostrarForm && (
          <div style={styles.form}>
            <h3 style={styles.formTitulo}>{editando ? 'Editar Contato' : 'Novo Contato'}</h3>
            <div style={styles.grid}>
              <div style={styles.campo}>
                <label style={styles.label}>Tipo *</label>
                <select style={styles.input} value={form.tipo_contato} onChange={e => setForm({ ...form, tipo_contato: e.target.value })}>
                  <option value="">Selecione...</option>
                  <option value="whatsapp">💬 WhatsApp</option>
                  <option value="email">✉️ Email</option>
                  <option value="outro">📞 Outro</option>
                </select>
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>Direção *</label>
                <select style={styles.input} value={form.direcao} onChange={e => setForm({ ...form, direcao: e.target.value })}>
                  <option value="entrada">⬇ Entrada</option>
                  <option value="saida">⬆ Saída</option>
                </select>
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>Cliente</label>
                <select style={styles.input} value={form.cliente_id} onChange={e => { setForm({ ...form, cliente_id: e.target.value, cliente_contato_id: '' }); carregarClienteContatos(e.target.value); }}>
                  <option value="">Selecione...</option>
                  {clientes.map(c => <option key={c.id} value={c.id}>{c.razao_social}</option>)}
                </select>
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>Contato da empresa</label>
                <select style={styles.input} value={form.cliente_contato_id} onChange={e => { const cc = clienteContatos.find(c => c.id === parseInt(e.target.value)); setForm({ ...form, cliente_contato_id: e.target.value, nome_contato: cc ? cc.nome : form.nome_contato }); }} disabled={!form.cliente_id}>
                  <option value="">Selecione...</option>
                  {clienteContatos.map(c => <option key={c.id} value={c.id}>{c.nome}{c.principal ? ' ★' : ''}</option>)}
                </select>
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>Contato externo (número/email)</label>
                <input style={styles.input} value={form.contato_externo} onChange={e => setForm({ ...form, contato_externo: e.target.value })} placeholder="11999999999 ou email@..." />
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>Data e hora *</label>
                <input style={styles.input} type="datetime-local" value={form.data_contato} onChange={e => setForm({ ...form, data_contato: e.target.value })} />
              </div>
              {form.tipo_contato === 'email' && (
                <div style={{ ...styles.campo, gridColumn: 'span 2' }}>
                  <label style={styles.label}>Assunto</label>
                  <input style={styles.input} value={form.assunto} onChange={e => setForm({ ...form, assunto: e.target.value })} />
                </div>
              )}
              <div style={{ ...styles.campo, gridColumn: 'span 2' }}>
                <label style={styles.label}>Resumo *</label>
                <textarea style={{ ...styles.input, height: '80px' }} value={form.resumo} onChange={e => setForm({ ...form, resumo: e.target.value })} placeholder="Resumo da conversa..." />
              </div>
            </div>
            <div style={{ display: 'flex', gap: '8px', marginTop: '1rem' }}>
              <button style={styles.botaoSalvar} onClick={salvar}>Salvar</button>
              <button style={styles.botaoCancelar} onClick={resetForm}>Cancelar</button>
            </div>
          </div>
        )}

        <table style={styles.tabela}>
          <thead>
            <tr>
              {['Tipo', 'Data', 'Cliente', 'Contato', 'Direção', 'Assunto/Resumo', 'Ações'].map(h => (
                <th key={h} style={styles.th}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtrados.map(c => (
              <tr key={c.id} style={{ ...styles.tr, ...(c.pendente_cadastro ? { backgroundColor: '#fff8e1' } : {}) }}>
                <td style={styles.td}>{iconeTipo(c.tipo_contato)} {c.tipo_contato}</td>
                <td style={{ ...styles.td, fontSize: '12px', color: '#888' }}>{formatarData(c.data_contato)}</td>
                <td style={styles.td}>
                  {c.pendente_cadastro
                    ? <span style={{ color: '#f57c00', fontSize: '12px' }}>⚠️ Pendente</span>
                    : nomeCliente(c.cliente_id)
                  }
                </td>
                <td style={styles.td}>{c.nome_contato || c.contato_externo || '-'}</td>
                <td style={styles.td}>
                  <span style={{ color: c.direcao === 'entrada' ? '#1976d2' : '#388e3c', fontSize: '12px' }}>
                    {c.direcao === 'entrada' ? '⬇ Entrada' : '⬆ Saída'}
                  </span>
                </td>
                <td style={{ ...styles.td, maxWidth: '300px' }}>
                  {c.assunto && <div style={{ fontSize: '11px', color: '#888', marginBottom: '2px' }}>{c.assunto}</div>}
                  <div style={{ fontSize: '13px', color: '#333', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.resumo}</div>
                </td>
                <td style={styles.td}>
                  {c.pendente_cadastro && (
                    <button style={styles.botaoVincular} onClick={() => vincular(c)}>Vincular</button>
                  )}
                  <button style={styles.botaoEditar} onClick={() => editar(c)}>Editar</button>
                  <button style={styles.botaoDeletar} onClick={() => deletar(c.id)}>✕</button>
                </td>
              </tr>
            ))}
            {filtrados.length === 0 && (
              <tr>
                <td colSpan={7} style={{ ...styles.td, textAlign: 'center', color: '#aaa', padding: '2rem' }}>
                  Nenhum contato encontrado
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const styles = {
  container: { display: 'flex', height: '100vh', overflow: 'hidden', backgroundColor: '#f0f2f5' },
  conteudo: { flex: 1, padding: '2.5rem', overflowY: 'auto' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' },
  titulo: { fontSize: '22px', color: '#1a1a2e', margin: 0 },
  badgePendente: { backgroundColor: '#fff3e0', color: '#f57c00', padding: '4px 10px', borderRadius: '20px', fontSize: '12px', fontWeight: '500' },
  botaoNovo: { backgroundColor: '#1a1a2e', color: '#fff', border: 'none', padding: '10px 18px', borderRadius: '6px', fontSize: '14px', cursor: 'pointer' },
  filtros: { display: 'flex', gap: '10px', marginBottom: '1.5rem', alignItems: 'center', flexWrap: 'wrap' },
  filtroInput: { padding: '8px 12px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '13px' },
  form: { backgroundColor: '#fff', padding: '1.5rem', borderRadius: '8px', marginBottom: '1.5rem', border: '1px solid #e0e0e0' },
  formTitulo: { margin: '0 0 1rem', fontSize: '16px', color: '#1a1a2e' },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' },
  campo: { display: 'flex', flexDirection: 'column' },
  label: { fontSize: '12px', color: '#555', marginBottom: '4px' },
  input: { padding: '9px 12px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px' },
  botaoSalvar: { backgroundColor: '#1a1a2e', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '6px', fontSize: '14px', cursor: 'pointer' },
  botaoCancelar: { backgroundColor: 'transparent', color: '#888', border: '1px solid #ddd', padding: '10px 20px', borderRadius: '6px', fontSize: '14px', cursor: 'pointer' },
  tabela: { width: '100%', borderCollapse: 'collapse', backgroundColor: '#fff', borderRadius: '8px', overflow: 'hidden' },
  th: { padding: '12px 16px', textAlign: 'left', fontSize: '12px', color: '#888', borderBottom: '1px solid #f0f0f0', fontWeight: '500' },
  tr: { borderBottom: '1px solid #f0f0f0' },
  td: { padding: '12px 16px', fontSize: '14px', color: '#333' },
  botaoEditar: { backgroundColor: 'transparent', color: '#1a1a2e', border: '1px solid #ddd', padding: '4px 10px', borderRadius: '4px', fontSize: '11px', cursor: 'pointer', marginRight: '4px' },
  botaoVincular: { backgroundColor: 'transparent', color: '#f57c00', border: '1px solid #f57c00', padding: '4px 10px', borderRadius: '4px', fontSize: '11px', cursor: 'pointer', marginRight: '4px' },
  botaoDeletar: { backgroundColor: 'transparent', color: '#e53935', border: '1px solid #e53935', padding: '4px 8px', borderRadius: '4px', fontSize: '11px', cursor: 'pointer' },
};